import { useEffect, useState } from "react";
import { Spin, Switch, Table, Tooltip } from "antd";
import { useAuthToken } from "../../components/usecontext/AuthContext";
import { message } from "../../components/antdMessageBridge";
import "../../components/commonpagination/common-pagination.css";
import { getQcConfig, updateQcConfig } from "../../components/qcconfig/qcConfigService";

const QcAccessControls = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [apiNoResults, setApiNoResults] = useState(false);
    const [updatingRoleIds, setUpdatingRoleIds] = useState([]);
    const { accessToken } = useAuthToken();

    const handleRestrictionToggle = async (roleId, checked) => {
        const previousData = data;

        setUpdatingRoleIds((prev) => [...prev, roleId]);
        setData((prev) =>
            prev.map((item) =>
                item.roleId === roleId
                    ? { ...item, editRestrictFieldAccess: checked }
                    : item
            )
        );

        try {
            await updateQcConfig({
                accessToken,
                isQcEnabled: checked ? 1 : 0,
            });

            message.success("QC config updated successfully.");
        } catch (err) {
            setData(previousData);
            message.error("Unable to update QC config. Please try again.");
            console.log("Update QC config error:", err);
        } finally {
            setUpdatingRoleIds((prev) => prev.filter((id) => id !== roleId));
        }
    };

    const columns = [
                 {
            title: "Page Name",
            dataIndex: "pageName",
            key: "pageName",
            width: 300,
             render: (value, record) => (
                <div>QC</div>
            ),
        },
        {
            title: "Enable QC",
            dataIndex: "editRestrictFieldAccess",
            key: "editRestrictFieldAccess",
            width: 300,
            render: (value, record) => (
                <Tooltip
                    title="Enable to show QC"
                    placement="right"
                    color="#ffffff"
                    overlayInnerStyle={{
                        color: "#1f2937",
                        border: "1px solid #d9d9d9",
                    }}
                >
                    <Switch
                        checked={Boolean(value)}
                        loading={updatingRoleIds.includes(record.roleId)}
                        disabled={updatingRoleIds.includes(record.roleId)}
                        data-track={
                            Boolean(value)
                                ? "field-role-management-disable-restriction"
                                : "field-role-management-enable-restriction"
                        }
                        onChange={(checked) =>
                            handleRestrictionToggle(record.roleId, checked)
                        }
                    />
                </Tooltip>
            ),
        },
    ];

        const fetchData = async () => {
        setLoading(true);
        try {
            const configValue = (await getQcConfig({ accessToken })) === 1;
            const formattedData = [
                {
                    roleId: "qc-config",
                    roleName: "QC",
                    assignedUsers: "All Users",
                    editRestrictFieldAccess: configValue,
                },
            ];

            setData(formattedData);
            setApiNoResults(formattedData.length === 0);
        } catch (err) {
            console.log("Fetch QC config error:", err);
            message.error(
                "Unable to load QC config. Please verify API base URL and endpoint routing."
            );
            setData([]);
            setApiNoResults(true);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    if (loading) {
        return <Spin size="large" style={{ margin: "20px auto" }} />;
    }

    return (
        <div className="active-page-container">
            <div className="active-page-header-container">
                <div className="active-page-header-title-container">
                    <h4>Qc Access Controls</h4>
                </div>
            </div>

            <div className="active-page-body-container">
                <div className="rounded-table-wrapper">
                    <Table
                        columns={columns}
                        dataSource={data}
                        className="common-pagination common-grid"
                        locale={{
                            emptyText: apiNoResults
                                ? "No records found."
                                : "No Data available.",
                        }}
                        pagination={false}
                        rowKey={(record) => record.roleId}
                        scroll={{
                            x: "max-content",
                            y: "calc(85vh - 280px)",
                        }}
                    />
                </div>
            </div>
        </div>
    );
};

export default QcAccessControls;
